import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import styles from "../ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>What is Google Tag Manager?</h3>
          <p>
            Google Tag Manager is an online system for managing tags on your
            website or app. Tags are small pieces of code that run on your site.
            For example you may want a conversion sent to your Facebook Business
            Manager account when someone clicks on the “Buy Now” button. This is
            in reality a small bit of code, triggered to fire when a particular
            element is clicked on your site. See below for example.
          </p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/sections/services/google-tag-manager-services/fb-pixel.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>An Example Tag: The Facebook Pixel</i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Why do you need Google Tag Manager?</h3>
          <p>
            Google Tag Manager (GTM) is the number 1 tool we recommend to all of
            our clients. Its that simple. You are at an immediate disadvantage
            if you don't use this or some other tagging solution. The reality is
            most site managers want to be able to track or make small changes
            (especially in response to marketing campaigns) to their site on a
            very regular basis. Having to manually go in and add snippets of
            code on a regular basis could be very time consuming, and prone to
            error.
            <br />
            <br />
            One of our clients has over 200 Google Analytics event/conversion
            tags on their site alone…. Imagine all these snippets of code buried
            into the site code/HTML? It quickly becomes a mess. GTM provides a
            central location to manage all of these tags in the one place. Rules
            are determined for when these tags are fired. So GTM becomes the
            control panel for every tag on your site.
            <br />
            <br />
            Benefits:
          </p>
          <ul>
            <li>Better organisation/less error</li>
            <li>
              Update tags to the site much quicker than manually adding to the
              site
            </li>
            <li>User access control</li>
          </ul>
        </GridItem>

        <GridItem
          xs={12}
          sm={10}
          md={10}
          className={classes.section}
          style={{ paddingTop: "10px" }}
        >
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/google-tag-manager-services/tag1-small.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Google Analytics Event Tag
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/google-tag-manager-services/tag2-small.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Facebook Conversion Tag
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/google-tag-manager-services/tag3-small.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Banner Ad visibility firing rules
                </i>
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            How Tribalism uses Google Tag Manager
          </h3>
          <p>
            The unsexy part about GTM is that it is a security risk, thus first
            and foremost we recognise and follow our established GTM procedures
            both for tag deployment and container access.
            <br />
            <br />
            We will always recommend to all clients that they remove hard coded
            GA from their site and instead deploy GA as a tag within GTM. This
            mitigates spammers crawling your site code and sending spam to your
            GA account via the measurement protocol.
            <br />
            <br />
            For multiple websites - eg Australian/US versions - we recommend
            deploying the same container across both sites instead of multiple
            containers. This increases complication yes - but reduces
            duplication work load which is even more prone to error.
            <br />
            <br />
            Depending on website size we can generally tag up an entire site in
            3 days. After reviewing our changes with you - our changes will be
            published by our senior consultants - only in the morning and
            especially never on a friday afternoon.
          </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Our guarantee to you</h3>

          <ol>
            <li>
              Quality: We will deliver quality work. It's the first thing all of
              our staff are trained in - “completed” is not good enough - it
              needs to be done well!
            </li>
            <li>
              Communication: We cannot guarantee that everything will be perfect
              the first time. Most things aren't. But what we can guarantee is
              easy communication to anyone in our business to discuss any issues
              and fix any problems asap.
            </li>
            <li>
              Innovative: We are anti-silo. Like life - you can't just focus on
              one thing to fix your problems. We are well versed on every facet
              of this field - and with that comes innovative approaches to your
              business issues.
            </li>
          </ol>

          <br />
          <br />
          <br />
        </GridItem>
      </GridContainer>
    </div>
  );
}
